const buttons = document.querySelectorAll( '.button_more' );

for ( let i = 0; i < buttons.length; i++ ) {
  buttons[ i ].addEventListener( 'click', function( event ) {
    const self = this;
    const request = new window.XMLHttpRequest();
    request.open( 'POST', window.more_ajax.url, true );
    request.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded;' );
    request.onload = function() {
      if ( this.status >= 200 && this.status < 400 ) {
        // If successful
        if ( this.response.trim().length ) {
          document.querySelector( '.posts-wrapper' ).insertAdjacentHTML( 'beforeend', this.response );
          window.more_ajax.paged++;
        }
        if ( this.response.trim().indexOf( 'next_page_empty' ) >= 0 || ! this.response.trim().length ) {
          const button = event.target;
          button.parentNode.removeChild( button );
        }
      } else {
        // If fail
        // eslint-disable-next-line no-console
        console.error( this.response );
      }
    };
    if ( ! window.more_ajax.paged ) {
      window.more_ajax.paged = 1;
    }
    const params = {
      action: 'cvle_more',
      paged: window.more_ajax.paged,
      offset: window.more_ajax.offset,
      cat: window.more_ajax.cat,
      type: self.dataset.type,
      load_more_nonce: window.more_ajax.load_more_nonce,
      posts_per_page: window.more_ajax.posts_per_page,
    };
    const data = Object.keys( params ).map( function( key ) {
      return key + '=' + params[ key ];
    } ).join( '&' );
    request.send( data );
  } );
}
